(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["personalization"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!window.customElements || window.customElements.get('tulip-personalization')) return;

    // Remembers what the customer typed, so it survives Horizon redrawing the block
    var store = {};

    function fillIn(template, values) {
      return String(template || '').replace(/\[(\w+)\]/g, function (match, key) {
        return values[key] != null ? values[key] : match;
      });
    }

    function setHidden(form, name, value) {
      var selector = 'input[type="hidden"][name="' + name.replace(/"/g, '\\"') + '"]';
      var field = form.querySelector(selector);
      if (!value) {
        if (field) field.remove();
        return;
      }
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = name;
        form.appendChild(field);
      }
      field.value = value;
    }

    class TulipPersonalization extends HTMLElement {
      constructor() {
        super();
        this.errorKind = null;
        this.onInput = this.onInput.bind(this);
        this.onClick = this.onClick.bind(this);
        this.refresh = this.refresh.bind(this);
      }

      get key() {
        return (this.dataset.productId || '') + ':' + (this.dataset.blockId || '');
      }

      get limit() {
        return parseInt(this.dataset.limit, 10) || 20;
      }

      parts() {
        return {
          input: this.querySelector('.tulip-pz__input'),
          toggle: this.querySelector('.tulip-pz__toggle'),
          panel: this.querySelector('.tulip-pz__panel'),
          count: this.querySelector('.tulip-pz__count'),
          err: this.querySelector('.tulip-pz__error')
        };
      }

      connectedCallback() {
        this.addEventListener('input', this.onInput);
        this.addEventListener('click', this.onClick);
        this.observer = new MutationObserver(this.refresh);
        this.observer.observe(this, { childList: true, subtree: true });
        this.refresh();
      }

      disconnectedCallback() {
        this.removeEventListener('input', this.onInput);
        this.removeEventListener('click', this.onClick);
        if (this.observer) this.observer.disconnect();
      }

      save() {
        var p = this.parts();
        if (!p.input) return;
        store[this.key] = { text: p.input.value, open: this.isOpen() };
      }

      isOpen() {
        var p = this.parts();
        return !p.panel || !p.panel.hidden;
      }

      setOpen(open) {
        var p = this.parts();
        if (!p.panel || !p.toggle) return;
        p.panel.hidden = !open;
        p.toggle.hidden = open;
        p.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      onClick(event) {
        var p = this.parts();
        if (event.target.closest('.tulip-pz__toggle')) {
          this.setOpen(true);
          this.save();
          if (p.input) p.input.focus();
        } else if (event.target.closest('.tulip-pz__remove')) {
          if (p.input) p.input.value = '';
          this.clearError();
          this.setOpen(false);
          this.save();
          this.updateCount();
          if (p.toggle) p.toggle.focus();
        }
      }

      onInput(event) {
        if (!event.target.matches('.tulip-pz__input')) return;
        this.save();
        if (this.errorKind === 'required' && event.target.value.trim()) this.clearError();
        this.updateCount();
      }

      // Restores the customer's text after Horizon redraws the page
      refresh() {
        var p = this.parts();
        if (!p.input) return;
        var saved = store[this.key];
        if (saved) {
          if (p.input.value !== saved.text) p.input.value = saved.text;
          if (saved.open && !this.isOpen()) this.setOpen(true);
        }
        this.updateCount();
      }

      updateCount() {
        var p = this.parts();
        if (!p.input || !p.count) return;
        var len = p.input.value.length;
        var text = len + ' of ' + this.limit;
        if (p.count.textContent !== text) p.count.textContent = text;

        if (len >= this.limit) {
          this.showError('limit', fillIn(this.dataset.msgLimit, { limit: this.limit }));
        } else if (this.errorKind === 'limit') {
          this.clearError();
        }
      }

      showError(kind, message) {
        var p = this.parts();
        if (!p.err) return;
        if (p.err.textContent !== message) p.err.textContent = message;
        p.err.hidden = false;
        this.errorKind = kind;
        if (p.input) {
          if (kind === 'limit') p.input.removeAttribute('aria-invalid');
          else p.input.setAttribute('aria-invalid', 'true');
        }
      }

      clearError() {
        var p = this.parts();
        if (p.err) {
          p.err.hidden = true;
          if (p.err.textContent) p.err.textContent = '';
        }
        if (p.input) p.input.removeAttribute('aria-invalid');
        this.errorKind = null;
      }

      validate() {
        var p = this.parts();
        if (!p.input) return true;
        var value = p.input.value.trim();

        if (this.dataset.required === 'true' && !value) {
          this.showError('required', this.dataset.msgRequired);
          p.input.focus();
          return false;
        }
        if (this.errorKind !== 'limit') this.clearError();
        return true;
      }

      writeTo(form) {
        var p = this.parts();
        var value = p.input && this.isOpen() ? p.input.value.trim() : '';
        setHidden(form, 'properties[' + this.dataset.property + ']', value);
      }

      clearFrom(form) {
        setHidden(form, 'properties[' + this.dataset.property + ']', '');
      }
    }

    window.customElements.define('tulip-personalization', TulipPersonalization);

    // Finds the personalization field that belongs to a given add-to-cart form
    function findFor(form) {
      var all = Array.prototype.slice.call(document.querySelectorAll('tulip-personalization'));
      if (!all.length) return null;
      var scope = form.closest('.shopify-section, dialog');
      var productInput = form.querySelector('input[name="product-id"]');

      if (productInput) {
        var matches = all.filter(function (el) {
          return el.dataset.productId === productInput.value;
        });
        if (!matches.length) return null;
        var inScope = scope && matches.filter(function (el) { return scope.contains(el); })[0];
        return inScope || matches[0];
      }
      return scope ? scope.querySelector('tulip-personalization') : null;
    }

    function handle(event, form) {
      if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      var el = findFor(form);
      if (!el) return;
      if (!el.validate()) {
        el.clearFrom(form);
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      el.writeTo(form);
    }

    // Capture phase runs before the theme's own add-to-cart handlers
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('button, input[type="submit"]');
      if (!button || button.type !== 'submit' || !button.form) return;
      handle(event, button.form);
    }, true);

    document.addEventListener('submit', function (event) {
      handle(event, event.target);
    }, true);

    // After a variant change, re-check once Horizon finishes updating the page
    document.addEventListener('variant:update', function () {
      function refreshAll() {
        document.querySelectorAll('tulip-personalization').forEach(function (el) {
          if (el.refresh) el.refresh();
        });
      }
      requestAnimationFrame(refreshAll);
      setTimeout(refreshAll, 300);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
